import { useTranslation } from 'next-i18next';
import { Heading } from '@restworld/ui-ds-base';
import { Button } from '@restworld/ui-ds-base';

export const CoverLetterQuickGuide = ({
  onClose,
  showCloseButton = true,
}: {
  onClose?: () => void;
  showCloseButton?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <Heading size={3} weight="semibold" className="leading-6.75">
          {t('onboarding-page:very_short_guide_to_present_yourself_at_your_best')}
        </Heading>
        <Heading size={6} weight="normal" color="muted" className="leading-6">
          {t('onboarding-page:the_best_advice_from_our_team')}
        </Heading>
      </div>
      <div className="flex flex-col gap-6">
        <div className="bg-primary-50 p-2 rounded w-fit">
          <Heading size={5} weight="semibold" color="primary" className="leading-6">
            {t('onboarding-page:4_tips_with_the_love')}
          </Heading>
        </div>
        <QuickGuideTitleAndSubTitle
          title={t('onboarding-page:be_essential_and_clear')}
          subTitle={t('onboarding-page:would_you_read_a_very_long_text')}
        />
        <QuickGuideTitleAndSubTitle
          title={t('onboarding-page:write_well_spelling_and_grammar')}
          subTitle={t('onboarding-page:if_italian_is_not_your_native_language_try_your_best')}
        />
        <QuickGuideTitleAndSubTitle
          title={t('onboarding-page:talk_about_why_youre_running_and_why_they_should_choose_you')}
        />
        <QuickGuideTitleAndSubTitle
          title={t('onboarding-page:be_original')}
          subTitle={t('onboarding-page:companies_receive_many_letters_every_day_all_the_samedifferentiated')}
        />
      </div>
      {showCloseButton ? (
        <Button variant="primary" fullwidth onClick={onClose}>
          {t('common:close')}
        </Button>
      ) : null}
    </div>
  );
};
const QuickGuideTitleAndSubTitle = ({ title, subTitle }: { title: string; subTitle?: string }) => {
  return (
    <div className="flex flex-col">
      <Heading size={5} weight="semibold" className="leading-6">
        {title}
      </Heading>
      {subTitle ? (
        <Heading size={6} weight="normal" color="muted" className="leading-5.25">
          {subTitle}
        </Heading>
      ) : null}
    </div>
  );
};
